import * as React from "react";
import Draggable from "react-draggable";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Paper
} from "@mui/material";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function DraggableDialog(props) {
  const [open, setOpen] = React.useState(false);
  const { linkText, titleText, url, innerHeight, innerWidth } = props;
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Link style={{ cursor: "pointer" }} onClick={handleClickOpen}>
        {linkText}
      </Link>
      <Dialog
        scroll="paper"
        open={open}
        onClose={handleClose}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {titleText}
        </DialogTitle>
        <DialogContent>
          <iframe
            width={innerWidth}
            height={innerHeight}
            src={url}
            title={linkText}
          ></iframe>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="contained" onClick={handleClose}>
            Schließen
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
